export const ID_GET_REQUEST = "ID_GET_REQUEST";
export const ID_GET_SUCCESS = "ID_GET_SUCCESS";
export const ID_GET_FAIL = "ID_GET_FAIL";
export const ID_RESET = "ID_RESET"